import { EpDevPError } from "./EpDevPError";

export class EpDevPApiServerError extends EpDevPError {
  public description: string;
  public status: number;
  public details: any;

  constructor(internalLogName: string, description: string, status: number, details?: any) {
    super(internalLogName, description);
    this.name = this.constructor.name;
    this.status = status;
    this.description = description;
    this.details = details;
  }
}

export class EpDevPServiceUnavailableError extends EpDevPApiServerError {
  public static ErrorName = "EpDevPServiceUnavailableError";
  private static DefaultDescription = 'Service unavailable';
  public static StatusCode = 503;

  constructor(internalLogName: string, details: any) {
    super(internalLogName, EpDevPServiceUnavailableError.DefaultDescription, EpDevPServiceUnavailableError.StatusCode, details);
    this.name = EpDevPServiceUnavailableError.ErrorName;
  }
}

export class EpDevPVerifySessionUserInfoError extends EpDevPApiServerError {
  private static DefaultDescription = 'Verify session user info';
  public static StatusCode = 510;

  constructor(internalLogName: string, details: any) {
    super(internalLogName, EpDevPVerifySessionUserInfoError.DefaultDescription, EpDevPVerifySessionUserInfoError.StatusCode, details);
  }
}

export class EpDevPEpApiCallError extends EpDevPApiServerError {
  private static DefaultDescription = 'Event Portal API Error';
  public static StatusCode = 502;
  constructor(internalLogName: string, details: any) {
    super(internalLogName, EpDevPEpApiCallError.DefaultDescription, EpDevPVerifySessionUserInfoError.StatusCode, details);
  }
}

export class EpDevPExternalApiCallAuthorizationError extends Error {
  private static DefaultDescription = 'Unauthorized';
  public static StatusCode = 401;
  public status: number;

  constructor() {
    super(EpDevPExternalApiCallAuthorizationError.DefaultDescription);
    this.name = EpDevPExternalApiCallAuthorizationError.DefaultDescription;
    this.stack = undefined;
    this.status = EpDevPExternalApiCallAuthorizationError.StatusCode;
  }

}

